<template>
  <div :id="'js-product-id--' + item.id" class="tag-product-item" :class="[{ 'tag-product-item--tag': is_tag }, {'is-tagged': item.is_tagged}, {'has-tagged': is_tag && has_tagged}]" @click="tagProduct">
    <!-- {{ is_tag }} - {{ item.in_curation_collection }} - {{ has_tagged }} - {{ props.is_not_show_is_tagged }} -->
    <div class="tagged-btns" v-if="is_tag && has_tagged">
      <ul>
        <li><el-button>Added</el-button></li>
        <li v-if="is_enable_color_size_picker && is_show_select_variants"><el-button class="add-btn" @click.stop="event.emit('select-variant', item)">Add new variant</el-button></li>
      </ul>
    </div>
    <figure>
      <el-image :src="item.images.img_400x400" fill="contain" alt="product image" @error="imageError" />
    </figure>

    <h3 class="name">
      <span class="product-name" :class="{'is-long-text': checkLongText(item.name, true)}" v-html="checkLongText(item.name)"></span>
      <strong v-if="item.brand_name" class="brand-name" v-html="item.brand_name"></strong>
    </h3>

    <div class="bot">
      <span class="price">{{ item.lowest_price }}</span>
      <i class="tag-ico" v-if="is_tag">
        <svg-icon name="checked-circle" />
      </i>
      <el-button @click="emit('remove')" type="text" size="small" v-else>
        <svg-icon name="delete" />
      </el-button>
    </div>

    <div class="select-variants" :key="selected_variants.length" :class="{'no-variants': !is_show_select_variants}" v-if="is_enable_color_size_picker">
      <span v-if="is_show_select_variants && selected_variants.length > 0">Selected: {{ selectedVariantText }}</span>
      <i v-if="is_show_select_variants && selected_variants.length > 0"><svg-icon name="arrow" /></i>
      <span v-else-if="is_show_select_variants">
        {{ variantsText }}
      </span>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, getCurrentInstance } from 'vue';
  import handleProductData from '@/utils/HandleProductData';
  import { ElButton, ElImage } from 'element-plus';
import { has } from 'lodash';

  const app = getCurrentInstance();
  const event = app.appContext.config.globalProperties.EventBus;
  const store = app.appContext.config.globalProperties.$store;

  // const { openNotBottom } = useNotification();
  const props = defineProps({
    product: {
      type: Object,
      required: true
    },
    is_tag: {
      type: Boolean,
      default: false
    },
    is_not_show_is_tagged: {
      type: Boolean,
      default: false
    },
    is_enable_color_size_picker: {
      type: Boolean,
      default: false
    },
    is_tagged: {
      type: Boolean,
      default: false
    },
    add_type: {
      type: String,
      default: ''
    }
  });

  const selected_variants = ref([]);
  const item = ref(handleProductData(props.product.product_detail ? props.product.product_detail : props.product));
  const emit = defineEmits(['tag', 'remove']);
  const has_tagged = computed(() => (
    (item.value.is_in_anchor_collection || 
      item.value.in_curation_collection ||
      item.value.is_in_anchor_post || 
      item.value.is_in_anchor_store_front
    ) && !props.is_not_show_is_tagged) || props.is_tagged);
  const is_show_select_variants = computed(() => {
    const getIsAdded = (item) => {
      if (props.add_type === 'storefront') {
        return item.is_added_in_storefront;
      } else if (props.add_type === 'collection') {
        return item.is_added_in_collection;
      } else if (props.add_type === 'post') {
        return item.is_added_in_post;
      }
      return false;
    };

    if ((item.value.unique_color_count + item.value.unique_size_count) < 2) return false;

    return item.value.total_color_size_map && item.value.total_color_size_map.length !== 0 && item.value.total_color_size_map.filter((item) => getIsAdded(item)).length <= item.value.total_color_size_map.length;
  });
  
  const variantsText = computed(() => {
    const colorText = item.value.unique_color_count ? item.value.unique_color_count + ' color' + (item.value.unique_color_count > 1 ? 's' : '') : '';
    const sizeText = item.value.unique_size_count ? item.value.unique_size_count + ' size' + (item.value.unique_size_count > 1 ? 's' : '') : '';
    return colorText + (colorText && sizeText ? ', ' : '') + sizeText;
  });

  const selectedVariantText = computed(() => {
    if (selected_variants.value.length === 0) return '';

    if (selected_variants.value.length === 1) {
      return selected_variants.value.map(variant => {
        const colorText = variant.color ? 'color ' + variant.color : '';
        const sizeText = variant.size ? 'size ' + variant.size : '';
        return colorText + (colorText && sizeText ? ', ' : '') + sizeText;
      }).join(', ');
    } else {
      return selected_variants.value.length + ' variants selected';
    }

  });

  const imageError = (e) => {
    // if image is error, remove self from list
    if (store.project === 'motom') {
      const product_el = document.getElementById(`js-product-id--${item.value.id}`);
      if (product_el) {
        product_el.remove();
      }
    }

  };



  const checkLongText = (text, isBoolean = false) => {
    if (!text) return isBoolean ? false : text;
    
    const trimmedText = text.trim();
    const hasNoSpaces = !trimmedText.includes(' ');
    const isLongText = hasNoSpaces && trimmedText.length > 40;
    
    if (isLongText) {
      if (isBoolean) {
        return true;
      } else {
        // max 60 characters
        return trimmedText.length > 80 ? trimmedText.substring(0, 60) + '...' : trimmedText;
      }
    } else {
      if (isBoolean) {
        return false;
      } else {
        return trimmedText;
      }
    }
  }

  const tagProduct = (e) => {
    const isClickInSelectVariants = e.target.closest('.select-variants');

    if (!props.is_tag) return;


    // if (props.is_enable_color_size_picker && item.value.total_color_size_map && item.value.total_color_size_map.length !== 0 && is_show_select_variants.value && !item.value.is_tagged) {
    
    if (props.add_type !== 'storefront' && !(props.is_enable_color_size_picker && item.value.total_color_size_map && item.value.total_color_size_map.length !== 0 && is_show_select_variants.value)) {
      emit('tag');
    }

    else if (!item.value.is_tagged || (item.value.is_tagged && isClickInSelectVariants)) {
      event.emit('select-variant', item.value);
      console.log('emit select-variant',item.value);
    } else {
      if (props.is_enable_color_size_picker && selected_variants.value.length > 0) {
        selected_variants.value = [];
        item.value.total_color_size_map.forEach((item) => {
          item.is_selected = false;
        });
      }
      
      // console.log('emit tag3');
      emit('tag');
    }
  }

  onMounted(() => {

    if (props.is_enable_color_size_picker && item.value.total_color_size_map && item.value.total_color_size_map.length !== 0) {
      selected_variants.value = item.value.total_color_size_map.filter((item) => {
        return item.is_selected;
      });
    }

    event.on('selected-variant', (obj) => {
      if (obj.id === item.value.id) {
        // console.log('obj', obj);

        // Filter out variants that have only color or only size if there's at least one variant with both
        const hasVariantWithBoth = obj.selectedVariants.variants.some(variant => variant.color && variant.size);
        if (hasVariantWithBoth) {
          obj.selectedVariants.variants = obj.selectedVariants.variants.filter(variant => variant.color && variant.size);
        }

        // First reset all is_selected to false
        item.value.total_color_size_map.forEach((item) => {
          item.is_selected = false;
        });

        // Then set matched variants to true
        obj.selectedVariants.variants.forEach((variant) => {
          const matchedVariant = item.value.total_color_size_map.find((item) => {
            const colorMatch = variant.color ? item.color === variant.color : true;
            const sizeMatch = variant.size ? item.size === variant.size : true;
            return colorMatch && sizeMatch;
          });

          if (matchedVariant) {
            matchedVariant.is_selected = true;
          }
        });

        // console.log('item.value', item.value)
        // console.log('obj', obj);

        // sycn product data
        item.value.post_to = obj.product.post_to;
        item.value.status = obj.product.status;
        item.value.permission = obj.product.permission;
        item.value.curation_collections = obj.product.curation_collections;
        item.value.scheduled_end = obj.product.scheduled_end;
        item.value.scheduled_start = obj.product.scheduled_start;
        item.value.scheduled_start_enabled = obj.product.scheduled_start_enabled;
        item.value.scheduled_end_enabled = obj.product.scheduled_end_enabled;
        item.value.notify_creators = obj.product.notify_creators;
        item.value.status_string = obj.product.status_string;
        item.value.is_sponsored_disclosure_enabled = obj.product.is_sponsored_disclosure_enabled;
        item.value.sponsored_disclosure_name = obj.product.sponsored_disclosure_name;
        
        selected_variants.value = item.value.total_color_size_map.filter((item) => item.is_selected);

        // console.log(selected_variants.value.length, obj.is_update)

        if (selected_variants.value.length !== 0 && obj.is_update) {
          // update tag
          // emit('tag', selected_variants.value);
        } else {
          // remove tag
          emit('tag');
        }


        // else {
        //   // variant not found
        //   openNotBottom('The variant not found', 'error');
        // }
      }
    });
  });


</script>

<style lang="scss">
.tag-product-item {
  border: 1px solid var(--Border-default);
  border-radius: var(--radius);
  padding: 2px;
  background-color: var(--Bg-light);
  display: grid;
  grid-template-rows: auto 1fr auto auto;

  &--tag {
    cursor: pointer;

    &:hover {
      border-color: var(--Neu-50);

      .bot .tag-ico {
        &::before {
          border-color: var(--Text-brand);
        }
      }
    }

    &.is-tagged {
      border-color: var(--Neu-70);

      .bot .tag-ico {
        &::before {
          display: none;
        }

        svg {
          display: block;
        }
      }

      &:hover {
        border-color: var(--Text-brand);
      }
    }
  }

  &.has-tagged {
    pointer-events: none;
    position: relative;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      background-color: rgba(0, 0, 0, 0.35);
    }

    .tagged-btns {
      position: absolute;
      z-index: 3;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      
      ul {
        li {
          padding: 4px 0;
        }

        .el-button {
          --ui-button-border-color: var(--ui-fill-color-blank);
          width: 128px;
          text-align: center;

          &.add-btn {
            pointer-events: auto;
          }
        }
      }
    }
  }
  
  figure {
    margin-bottom: 12px;
    display: block;
    padding-bottom: 100%;
    position: relative;
    border-radius: var(--radius-small);
    overflow: hidden;
    background-color: var(--Bg-light);

    .el-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: block;

      img {
        object-fit: contain;
      }
    }
  }

  h3 {
    margin-bottom: 10px;
    padding: 0 8px;
  }

  .product-name {
    font: var(--medium-12);
    color: var(--Text-secondary);
    display: block;
    
    &.is-long-text {
      word-break: break-all;
    }
  }

  .brand-name {
    font: var(--demi-12);
    color: var(--Text-secondary);
  }

  .bot {
    display: flex;
    align-items: center;
    padding: 0 8px 6px;

    .price {
      font: var(--medium-16);
      color: var(--Text-primary);
      flex: 1;
    }

    .el-button {
      padding-left: 4px;
      padding-right: 4px;

      svg {
        height: 16px;
        width: 16px;
        margin: 0;
      }
    }

    .tag-ico {
      position: relative;
      height: 20px;
      width: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      &::before {
        height: 18px;
        width: 18px;
        border-radius: 50%;
        border: 2px solid var(--Black-60);
        content: '';
        box-sizing: border-box;
      }

      svg {
        height: 100%;
        width: 100%;
        fill: var(--Text-brand);
        display: none;
      }
    }
  }

  .select-variants {
    padding: 8px;
    min-height: 34px;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: var(--Text-primary);
    background-color: var(--Bg-01);
    cursor: pointer;

    &.no-variants {
      background-color: var(--Black-00);
    }

    span {
      flex: 1;
    }

    i {
      height: 8px;
      width: 8px;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        height: 100%;
        width: 100%;
        fill: var(--Text-secondary);
        transform: rotate(-90deg);
      }
    }

    &:hover {
      color: var(--Text-brand);

      i {
        svg {
          fill: var(--Text-brand);
        }
      }
    }

  }
}
</style>